// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__PKYOE","content":"LayoutSettings_content__3oMQ9"};